// import { DndContext, closestCenter } from '@dnd-kit/core';
// import { SortableContext, arrayMove, useSortable } from '@dnd-kit/sortable';
// import { CSS } from '@dnd-kit/utilities';
// import { useSearchParams } from 'react-router-dom';
// import api from '@api'; // Instead of ../../../utils/api
// import React, { useEffect, useState } from 'react';
// import './StatAuth.css';
// import { useAuth } from '../../context/AuthContext';

// function Stats() {
//   const [stats, setStats] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [newStat, setNewStat] = useState({ name: '', shortName: '' });
//   const { user } = useAuth();
//   const [searchParams] = useSearchParams();
//   const overrideUserId = searchParams.get("userId");
//   const [targetUser, setTargetUser] = useState(null);

//   useEffect(() => {
//     const fetchUserById = async () => {
//       if (!overrideUserId) return;
//       try {
//         const response = await api.get(`/api/users/${overrideUserId}`, { withCredentials: true });
//         setTargetUser(response.data.user);
//       } catch (error) {
//         console.error("Error fetching override user:", error);
//       }
//     };
//     fetchUserById();
//   }, [overrideUserId]);


//   const fetchStatsBySport = async () => {
//     const u = overrideUserId ? targetUser : user;
//     if (!u || !u.sports || u.sports.length === 0) return;
//     try {
//       const sportId = u.sports[0].id;
//       const response = await api.get(`/api/stats/${sportId}${overrideUserId ? `?userId=${overrideUserId}` : ''}`);
//       setStats(response.data);
//     } catch (error) {
//       console.error("Error fetching stats:", error);
//     }
//     setLoading(false);
//   };


//   useEffect(() => {
//     fetchStatsBySport();
//   }, [user, targetUser, overrideUserId]);


//   const handleDragEnd = async (event) => {
//     const { active, over } = event;
//     if (!over || active.id === over.id) return; // ✅ Prevent unnecessary updates
//     // Get indexes before and after drag
//     const oldIndex = stats.findIndex(stat => stat.id === active.id);
//     const newIndex = stats.findIndex(stat => stat.id === over.id);
//     // ✅ Reorder stats in state
//     const reorderedStats = arrayMove(stats, oldIndex, newIndex);
//     setStats(reorderedStats);
//     try {
//       // ✅ Save the new order in the database
//       await api.put('/api/stats/reorder', {
//         stats: reorderedStats.map((stat, index) => ({ id: stat.id, order: index })),
//       });
//       // ✅ Fetch the updated stats again from the backend to confirm order
//       fetchStatsBySport();
//     } catch (error) {
//       console.error("Error updating stat order:", error);
//     }
//   };


//   const handleHideStat = async (id, currentVisibility) => {
//     try {
//       const query = overrideUserId ? `?userId=${overrideUserId}` : '';
//       await api.put(`/api/stats/${id}/toggle-visibility${query}`, {
//         hidden: !currentVisibility,
//       });
//       setStats((prevStats) =>
//         prevStats
//           .map(stat =>
//             stat.id === id ? { ...stat, hidden: !currentVisibility } : stat
//           )
//           .sort((a, b) => a.order - b.order)
//       );
//     } catch (error) {
//       console.error("Error hiding stat:", error);
//     }
//   };


//   const handleResetStats = async () => {
//     if (!window.confirm("Are you sure you want to reset stats to default? This will remove duplicates and restore original stats.")) return;
//     try {
//       const u = overrideUserId ? targetUser : user;
//       if (!u || !u.sports || u.sports.length === 0) return alert("No sport found.");
//       const sportId = u.sports[0].id;
//       await api.post('/api/stats/reset', { sportId, userId: overrideUserId });
//       fetchStatsBySport(); // ✅ Refresh the stats after reset
//     } catch (error) {
//       console.error("Error resetting stats:", error);
//     }
//   };


//   const handleAddStat = async () => {
//     if (!newStat.name || !newStat.shortName) {
//       return alert("Please fill all fields");
//     }
//     try {
//       const u = overrideUserId ? targetUser : user;
//       if (!u || !u.sports || u.sports.length === 0) return alert("No sports available.");
//       const sportId = u.sports[0].id;
//       const response = await api.post('/api/stats', { sportId, name: newStat.name, shortName: newStat.shortName, userId: overrideUserId });
//       setStats([...stats, response.data]); // ✅ Add new stat to the list
//       setNewStat({ name: '', shortName: '' }); // ✅ Reset input fields
//     } catch (error) {
//       console.error("Error adding stat:", error);
//     }
//   };

//   if (!user) return <p>Loading user...</p>;
//   if (loading) return <p>Loading stats...</p>;

// console.log('hi')

//   return (
//     <div className="statAuth-container">
//       <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}> 
//         <SortableContext items={stats.map(stat => stat.id)}> 
//           <div className="stats-list">
//             {stats.map((stat) => (
//               <SortableStat key={stat.id} stat={stat} onHide={handleHideStat} />
//             ))}
//           </div>
//         </SortableContext>
//       </DndContext>

//       <div className="bottom-stat">
//         <div className="add-stat-form">
//           <h3>Add New Stat</h3>
//           <form onSubmit={(e) => {
//             e.preventDefault();
//             if (!newStat.name || !newStat.shortName) return alert("Please fill all fields");
//             handleAddStat();
//           }}>
//             <input
//               type="text"
//               placeholder="Stat Name"
//               value={newStat.name}
//               onChange={(e) => setNewStat({ ...newStat, name: e.target.value })}
//             />
//             <input
//               type="text"
//               placeholder="Short Name"
//               value={newStat.shortName}
//               onChange={(e) => setNewStat({ ...newStat, shortName: e.target.value })}
//             />
//             <button className='add-stat-btn' type="submit">Add Stat</button>
//           </form>
//           <button className="reset-button" onClick={handleResetStats}>Reset Stats</button> {/* ✅ Reset Button */}
//         </div>
//       </div>
//     </div>
//   );
// }

// function SortableStat({ stat, onHide }) {
//   const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: stat.id });
//   const style = {
//     transform: CSS.Transform.toString(transform),
//     transition,
//     cursor: "grab",
//     opacity: stat.hidden ? 0.5 : 1,  // ✅ Gray out hidden stats
//   };

//   return (
//     <div ref={setNodeRef} style={style} className="stat-item">
//       <h3 {...attributes} {...listeners}>
//         {stat.name} ({stat.shortName})
//       </h3>
//       <button
//         onClick={(e) => {
//           e.stopPropagation();
//           onHide(stat.id, stat.hidden);
//         }}
//       >
//         {stat.hidden ? 'Unhide' : 'Hide'}
//       </button>
//     </div>
//   );
// }

// export default Stats;

import React, { useEffect, useState } from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, arrayMove, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useParams } from 'react-router-dom';
import api from '@api';
import { useAuth } from '../../../../context/AuthContext';
import './StatAuth.css';

function StatAuth() {
  const [stats, setStats] = useState([]);
  const [sportId, setSportId] = useState(null)
  const [loading, setLoading] = useState(true);
  // const [newStat, setNewStat] = useState({ name: '', abbreviation: '' });
  const { user } = useAuth();
  const { id } = useParams();
  const targetOrgId = id || user?.organization_id;
  //   const [searchParams] = useSearchParams();
  //   const urlSlug = searchParams.get("slug") || window.location.pathname.split('/')[1];
  //   const effectiveSlug = user?.slug || urlSlug;

  //   const overrideUserId = searchParams.get("userId");
  //   const [targetUser, setTargetUser] = useState(null);
  // console.log(user)
  //   useEffect(() => {

  //     const fetchUserById = async () => {
  //       if (!overrideUserId) return;
  //       try {
  //         const response = await api.get(`/api/usersv2/${overrideUserId}`);
  //         setTargetUser(response.data.user);
  //       } catch (error) {
  //         console.error("Error fetching override user:", error);
  //       }
  //     };
  //     fetchUserById();
  //   }, [overrideUserId]);
  const fetchStatsBySport = async () => {
    if (!sportId) return;
    try {
      const response = await api.get(`/api/statsv2/${sportId}`, {
        params: { organization_id: targetOrgId },
      });
      setStats(response.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchSportIdForOrg = async () => {
      if (!targetOrgId) return;

      try {
        const res = await api.get(`/api/sportsv2/byOrg/${targetOrgId}`);
        const sport = res.data.sports?.[0]; // ⛔ if multiple sports, add a dropdown later
        if (sport?.id) {
          setSportId(sport.id);
        } else {
          console.warn("No sport found for this organization");
        }
      } catch (err) {
        console.error("Failed to fetch sport:", err);
      }
    };

    fetchSportIdForOrg();
  }, [targetOrgId]);

  useEffect(() => {
    fetchStatsBySport();
  }, [sportId]);


console.log(stats)
  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIndex = stats.findIndex(stat => stat.id === active.id);
    const newIndex = stats.findIndex(stat => stat.id === over.id);
    const reorderedStats = arrayMove(stats, oldIndex, newIndex);
    setStats(reorderedStats);
    try {
      await api.put('/api/statsv2/reorder', {
        stats: reorderedStats.map((stat, index) => ({ id: stat.id, order: index })),
      });
      fetchStatsBySport();
    } catch (error) {
      console.error("Error updating stat order:", error);
    }
  };

  const toggleVisibility = async (id, currentVisibility) => {
    try {
      await api.put(`/api/statsv2/${id}/toggle-visibility`, {
        hidden: currentVisibility,
        organization_id: targetOrgId,
      });
      setStats((prev) =>
        prev.map((s) => (s.id === id ? { ...s, is_visible: !currentVisibility } : s))
      );
    } catch (error) {
      console.error("Error toggling visibility:", error);
    }
  };

  // const handleResetStats = async () => {
  //   if (!window.confirm("Reset stats to default? This will overwrite current stats.")) return;
  //   try {
  //     if (!sportId) return alert("No sport found.");
  //     await api.post('/api/statsv2/reset', { sport_id: sportId });
  //     fetchStatsBySport();
  //   } catch (error) {
  //     console.error("Error resetting stats:", error);
  //   }
  // };

  // const handleAddStat = async () => {
  //   if (!newStat.name || !newStat.abbreviation) {
  //     return alert("Please fill all fields");
  //   }
  //   try {
  //     if (!sportId) return alert("No sport found.");
  //     const response = await api.post('/api/statsv2', {
  //       sport_id: sportId,
  //       name: newStat.name,
  //       abbreviation: newStat.abbreviation,
  //     });
  //     setStats([...stats, response.data]);
  //     setNewStat({ name: '', abbreviation: '' });
  //   } catch (error) {
  //     console.error("Error adding stat:", error);
  //   }
  // };

  if (!user) return <p>Loading user...</p>;
  if (loading) return <p>Loading stats...</p>;

  return (
    <div className="stats-v2-container">
      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={stats.map(stat => stat.id)}>
          <div className="stats-list">
            {stats.map((stat) => (
              <SortableStatV2 key={stat.id} stat={stat} onToggleVisibility={toggleVisibility} />
            ))}
          </div>
        </SortableContext>
      </DndContext>

      {/* <div className="add-stat-section">
        <h3>Add New Stat</h3>
        <form onSubmit={(e) => {
          e.preventDefault();
          handleAddStat();
        }}>
          <input
            type="text"
            placeholder="Stat Name"
            value={newStat.name}
            onChange={(e) => setNewStat({ ...newStat, name: e.target.value })}
          />
          <input
            type="text"
            placeholder="Abbreviation"
            value={newStat.abbreviation}
            onChange={(e) => setNewStat({ ...newStat, abbreviation: e.target.value })}
          />
          <button type="submit">Add Stat</button>
        </form>
        <button className="reset-button" onClick={handleResetStats}>Reset to Default</button>
      </div> */}
    </div>
  );
}

function SortableStatV2({ stat, onToggleVisibility }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: stat.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
    opacity: stat.is_visible ? 1 : 0.5,
  };

  return (
    <div ref={setNodeRef} style={style} className="stat-item">
      <h3 {...attributes} {...listeners}>
        {stat.name} ({stat.abbreviation})
      </h3>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggleVisibility(stat.id, stat.is_visible);
        }}
      >
        {stat.is_visible ? 'Hide' : 'Unhide'}
      </button>
    </div>
  );
}

export default StatAuth;
